import { render, staticRenderFns } from "./MasterSlaveGrid.vue?vue&type=template&id=ce934f28&scoped=true&"
import script from "./MasterSlaveGrid.vue?vue&type=script&lang=js&"
export * from "./MasterSlaveGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce934f28",
  null
  
)

export default component.exports